import kujipy from '../assets/kujipy.webp';
import tiptsy from '../assets/tiptsy.webp';
import tiptsy2 from '../assets/tiptsy2.webp';
import grupo1 from '../assets/grupo1.webp';
import musicos from '../assets/musicos.webp';
import tiptsy3 from '../assets/tiptsy3.webp';
import tiptsy4 from '../assets/tiptsy4.webp';
import tiptsy5 from '../assets/tiptsy5.webp';
import tiptsy6 from '../assets/tiptsy6.webp';
import tiptsy7 from '../assets/tiptsy7.webp';
import musicos2 from '../assets/musicos2.webp';
import musicos3 from '../assets/musicos3.webp';
import musicos4 from '../assets/musicos4.webp';
import musicos5 from '../assets/musicos5.webp';
import musicos6 from '../assets/musicos6.webp';
import musicos7 from '../assets/musicos7.webp';


const galleryImages = [
  
    {
      src: kujipy,
      text: "kujipy",
      orientacion: "vertical"
    },
    {
      src: tiptsy,
      text: "tiptsy",
      orientacion: "horizontal"
    },
    {
      src: tiptsy2,
      text: "tiptsy2",
      orientacion: "vertical"
    },
    {
      src: grupo1,
      text: "grupo1",
      orientacion: "horizontal"
    },
    {
      src: tiptsy3,
      text: "tiptsy3",
      orientacion: "vertical"
    },
    {
      src: tiptsy4,
      text: "tiptsy4",
      orientacion: "horizontal"
    },
    {
      src: tiptsy5,
      text: "tiptsy5",
      orientacion: "vertical"
    },
    {
      src: tiptsy6,
      text: "tiptsy6",
      orientacion: "vertical"
    },
    {
      src: musicos,
      text: "musicos",
      orientacion: "vertical"
    },
    {
      src: musicos2,
      text: "musicos2",
      orientacion: "vertical"
    },
    {
      src: musicos3,
      text: "musicos3",
      orientacion: "vertical"
    },
    {
      src: musicos4,
      text: "musicos4",
      orientacion: "horizontal"
    },{
      src: musicos5,
      text: "musicos5",
      orientacion: "vertical"
    },
    {
      src: musicos6,
      text: "musicos6",
      orientacion: "vertical"
    },
    {
      src: musicos7,
      text: "musicos7",
      orientacion: "vertical"
    },
    {
      src: tiptsy7,
      text: "tiptsy7",
      orientacion: "vertical"
    },
];

export default galleryImages;
